import React, { Fragment } from 'react';
import Details from './details';

const PageListing = () => (
  <>
    <div className="content-header">
      <h1>Area</h1>
    </div>

    <Details />
  </>
);

export default PageListing;
